export class GetPastSurgicalHX {
    pasT_SURGICAL_HISTORY_STRUCTURE_ID: string;
    patienT_ACCOUNT: string;
    encounteR_ID: string;
    practicE_CODE: string;
    surgerY_DATE: string;
    surgerY_NAME: string;
    surgerY_PLACE: string;
    posT_SURGERY_COMPLICATIONS: string;
    createD_BY: string;
    createD_DATE: string;
    modifieD_BY: string;
    modifieD_DATE: string;
}



export class SavePastSurgicalHX 
{
    pastSurgicalHistoryStructureReconcileId: string = "";
    patientAccount: string = "";
    language: string = '';
    practiceCode: string = "";
    surgeryDate: string = "";
    surgeryName: string = "";
    surgeryPlace: string = "";
    postSurgeryComplications: string = "";
    createdBy: string = "";  
}

